module.exports = {
  global: {
    title:'Answer.AI Data',
    switch_lang:'english',
    back_to_app_homepage:'返回应用首页',
    exit: '退出',
    save:'保存',
    save_success:'保存成功',
    icon:'图标',
    choose_image:'选择图片',
    selected_icon:'选中图标',
    add:'添加',
    created:'创建',
    start_time:'开始时间',
    end_time:'结束时间',
    duration:'持续时间',
    sort:'排序'
  },
  components:{
    common:{
      input_time:'输入时间',
      add:'添加',
      tiao:' 条',
      check_all:'全选',
    },
    tree:{
      placeholder:'输入关键字进行过滤',
      nodata:'暂无数据'
    },
    webuploader:{
      select_file:'选择文件',
      upload_success:'上传成功',
      upload_failed:'上传失败,请重试',
    },
    container:{
      authority_management:'权限管理',
      barrage_management:'弹幕管理',
      user_management:'用户管理',
      member_management:'会员管理',
      gold_management:'金币管理',
      commodity_management:'商品管理',
      log_management:'日志管理',
      feedback:'意见反馈',
      dibble_seeding_media_management:'点播媒资管理',
      live_media_management:'直播媒资管理',
      config_management:'配置管理',
      ad_management:'广告管理',
      cdn_management:'CDN管理',
      operations_management:'APPS',
      system_settings:'系统设置',
      chat_query:'对话查询',
      monitor_management:'数据表监控',
    },
    ooperatepanel:{
      search:'搜索',
      empty:'清空',
      filter_condition:'筛选条件',
    },
    popedit:{
      add_image:'添加图片',
    },
    property_select:{
      more:'更多',
      select:'选择',
    },
    tablepanel:{
      selected:'已选择 ',
      check:'查看',
    },
    uploadfile:{
      upload_progress:'上传进度',
      select_file:'选择文件',
      upload_success:'上传成功',
      upload_failed:'上传失败,请重试',
    },
    vpage:{
      previous_page:'上一页',
      next_page:'下一页',
      the:'第',
      page:'页',
      each_page:'每页',
      total:'共',
    },
    vselect:{
      input_search:' 输入搜索',
      empty:'空',
    }
  },
  cms:{
    ad:{
      common:{
        name:'名称',
        ad_name:'广告名称',
        disable:'禁用',
        start_using:'启用',
        operation:'操作',
        amend:'修改',
        del:'删除',
        remove:'移除',
        add:'添加',
        seconds:'秒',
        associated_ad:'关联广告',
        relevant_channel:'关联渠道',
        connected_channels:'已关联渠道',
        live_channels:'直播频道',
        creation_time:'创建时间',
        state:'状态',
        choose:'选择',
        click_select:'点击选择',
        send:'发送',
        page:'页面',
        page_screening:'页面筛选',
        add_ad:'添加广告',
        add_ad_unit:'添加广告单元',
        series:'剧集',
        advertisers:'广告商',
        set_time:'时间段设置',
        content_customized_state:'内容定制（分别对某个频道或视频设置IVA广告，可以分别设置出现的时间段，最灵活）',
        volume_set_state:'批量设置（同时设置多个内容的IVA广告，出现的时间段都相同）',
        send_instantly_state:'即时发送（立即向某个直播频道发送一条IVA广告）',
        intelligent_analysis_put_autonomy:'智能分析（自主投放）',
        effective_time:'开始生效时间',
        closing_time:'结束生效时间',
        sowing_start_time:'起播后开始时间',
        operation_platform:'操作平台',
        relevance_app:'关联应用',
        all:'所有',
        ad_type:'广告类型',
        put_scope:'投放范围',
        video_dibble_seeding:'点播视频',
        policy_type:'策略类型',
        show_length:'间隔时长',
        associated_resources:'资源关联',
        determine:'确定',
        occurrences:'出现次数',
        type:'类型',
        channel:'渠道',
        channel_name:'频道名称',
        ad_space_management:'广告位管理',
        put_channel:'投放渠道',
        ad_space_screening:'广告位置筛选',
        ad_space_name:'广告位置名称',
        ad_unit_control_amount:'广告单元控量',
        configure_version:'配置版本',
        dibble_seeding:'点播',
        dibble_seeding_show:'点播节目',
        live:'直播',
        input_id_or_keyword:'输入id或关键字',
        select_file:'选择文件',
        write_URL:'填写URL',
        jump_type:'跳转类型',
        app_name:'应用名称',
        third_party_display_statistics:'第三方展示统计',
        third_party_click_statistics:'第三方点击统计',
        ad_page:'广告页面',
        ad_material:'广告素材',
        set_time_quantum:'修改时间段设置',
        operator_ad:'运营商广告',
        since_vote_ad:'自投广告',
        time:'时间',
        confirm_new:'确认新增',
        confirm_change:'确认修改',
        video_name:'视频名称',
        episode_name:'剧集名称',
        choose_show:'选择剧集',
        send_success:'发送成功',
        ad_unit_name:'广告单元名称',
        provider:'提供商',
        config_control_amount:'配置控量',
        batch_delete:'批量删除',
        weight:'权重',
        start_time:'开始时间',
        duration:'持续时长',
      },
      addconfig_add:{
        select_location_name:'选择位置名称',
        select_ad:'选择广告',
        select_version:'选择版本'
      },
      adcontrol_add:{
        max_num_requests:'最大请求数',
        min_num_show:'最大展示数',
        min_num_click:'最大点击数',
        start_time:'开始时间',
        end_time:'结束时间',
        config_sort:'配置排序'
      },
      adcontrol_list:{
        ad_control_amount:'广告控量',
        ad_all_control_amount:'所有广告控量',
        add_putIn_equipment:'增加投放配置',
        whether_disable:'是否禁用',
        whether_reach_require:'是否达到要求',
        whether_overdue:'是否过期',
        reach_require:'达到要求',
        miss_require:'未达要求',
        has_overdue:'已过期',
        no_overdue:'未过期',
        requestNum_or_maxRequestNum:'请求数/最大请求数',
        showNum_or_maxShowNum:'展示数/最大展示数',
        clickNum_or_maxClickNum:'点击数/最大点击数',
        overdue:'过期',
      },
      adcustom_add:{
        compile_directMail:'直投广告编辑',
        recommendedLanguage:'推荐语',
        ad_present_time:'广告呈现时间(秒)',
        ad_action:'广告动作',
        click_jumpAdd:'点击跳转地址',
        up_package:'上传安装包',
        app_packageName:'应用包名',
        write_telNum:'填写电话号码',
        click_describe:'点击描述',
        describe:'描述',
        for_details:'了解详情',
        app_ad:'app广告',
        img_ad:'图片广告',
        video_ad:'视频广告',
        fullScreen_click:'全屏点击',
        adContent_click:'广告内容点击',
        silent_install:'静默安装',
        bound_install:'捆绑安装',
        call_up:'拨打电话',
        h5_external_links:'外部H5链接',
        app_download_links:'App下载链接',
        system_call:'系统调用',
        no_turnOff:'不可关闭',
        can_turnOff:'可关闭'
      },
      adcustom_config:{
        video_title:'视频标题',
        time_quantum_num:'时间段数量'
      },
      adcustom_list:{
        direct_mail_ad_management:'直投广告管理',
        put_broadcast_channel:'投放直播频道',
        put_dibble_seeding_video:'投放点播视频'
      },
      add_stream_config:{
        period_time:'时间段'
      },
      add_video_config:{
      },
      adiva_add:{
        IVA_add_set:'IVA广告编辑',
        position_size:'位置尺寸',
        width:'宽度',
        height:'高度',
        padding:'内边距',
        align_edge:'对齐边',
        top:'上',
        bottom:'下',
        left:'左',
        reight:'右',
        center:'中',
        lower_left:'左下',
        jumpURL:'跳转URL',
        ad_style:'广告样式',
        intelligent_analysis_put:'智能分析（Yi+投放）',
        scene_label:'场景标签',
        slide:'滑动',
        lucency:'透明'
      },
      adiva_config:{
      },
      adiva_list:{
        IVA_add_management:'IVA广告管理',
        unknown:'未知',
        content_customized:'内容定制',
        volume_set:'批量设置',
        send_instantly:'即时发送',
        intelligent_analysis:'智能分析',
        put_autonomy:'自主投放',
        launch_strategy:'投放策略',
        change_basicInfo:'修改基本信息',
        IVA_ad:'IAV广告'
      },
      adiva_recognition:{
        IVA_identification_taskList:'IVA识别任务列表',
        content_type:'内容类型',
        show_name:'剧集名称',
        advertising_point:'广告投放点',
        result_count:'结果数量',
        task_status:'任务状态',
        cancel:'取消',
        continue:'继续',
        pause:'暂停',
        stick:'置顶',
        retest:'重新检测',
        the:'第',
        episode:'集',
        choose_tag:'选择标签',
        min_duration:'最小时长',
      },
      adiva_strategy:{
        custom_launch_strategy:'定制投放策略',
        policy_name:'策略名称',
        dibble_seeding_show:'点播剧集'
      },
      adiva_tag:{
        IVA_adLabel_management:'IVA广告标签管理',
        label_name:'标签名称',
        label_tag:'标签分类',
        choose_label_tag:'选择标签分类'
      },
      adprovider_add:{
        select_advertisers:'选择广告商',
        specify_application:'指定应用',
        universal:'通用',
        dedicated:'专用',
        choose_app:'选择应用'
      },
      adprovider_list:{
        ad_provider:'广告供应商',
        add_ad_provider:'增加广告供应商'
      },
      adunit_add:{
        choose_direct_mail_ad:'选择直投广告',
        operator_ad_provider:'运营商广告提供商',
        platform:'平台',
        operator_ad_bit_id:'运营商广告位ID',
        ad_form:'广告形式',
        direct_mail_ad:'直投广告',
        iva_ad:'IVA广告',
        ad_categories:'广告类别'
      },
      adunit_app:{
        ad_unit_association_app:'广告单元关联应用',
        app_type:'应用类型',
        associated_version:'关联版本',
        disassociation:'取消关联'
      },
      adunit_control:{
      },
      adunit_list:{
        ad_unit_management:'广告单元管理',
        new_ad_unit:'新增广告单元',
        app:'应用',
        channel_choose:'渠道选择',
        territory:'地域'
      },
      adunit_setting_list:{
        ad_unit_set:'广告单元设置',
        version_set:'版本设置',
        global_set:'全局设置',
        prompt:'*如果设置了权重，则出现的规则根据权重设定',
        ad_unit_id:'广告单元ID'
      },
      app_ad_channel:{
      },
      app_ad_list:{
        version:'版本',
        association_ad_unit:'关联广告单元'
      },
      appcontrol_list:{
      },
      channel:{
      },
      list:{
        ad_list:'广告列表',
        new_ad:'新增广告',
        ad_unit_num:'广告单元数量',
        ad_placename:'广告位名称',
        ad_unit:'广告单元'
      },
      push:{
        video_type:'视频类型',
        creator:'创建人'
      },
      select_custom:{
      },
      select_iva:{
      },
      update:{
        ad_space:'广告位置',
        refresh_interval:'刷新间隔'
      },
      version:{
        already_relevant_version:'已关联版本',
        platform_type:'平台类别',
        version_name:'版本名称',
        version_number:'版本号'
      }
    },
    app:{
      common:{
        select:'选择',
        confirm:'确定',
        app_name:'APP 应用名称',
        platform:'平台',
        package_name:'包名',
        all:'所有',
        state:'状态',
        enable:'允许操作',
        no_operation:'不允许操作',
        sort:'类别',
        ios_version:'ios版本',
        android_version:'android版本',
        support_language:'支持语言',
        creation_time:'创建时间',
        operation:'操作',
        compile:'编辑',
        resource_management:'资源管理',
        version_management:'版本管理',
        default_setting:'默认设置',
        setting:'设置',
        delete:'删除',
        content_management:'内容管理',
        choose_channel:'选择渠道',
        name:'名称',
        use:'应用',
        up_way:'升级方式',
        bounced_up:'弹框升级',
        force_up:'强制升级',
        version_set:'版本设置',
        create_new_version:'创建新版本',
        version_number:'版本号',
        copy_version:'复制版本',
        version_id:"ID",
        version_name:'版本名称',
        installation_number:'安装数量',
        version:'版本',
        duplicate_content:'复制内容',
        stop_maintenance:'停止维护',
        open_maintenance:'开启维护',
        select_resource:'选择资源',
        under_maintenance:'维护中',
      },
      language:{
        keywords:'关键词',
        language_name:'语言名称',
        local_name:'本地名称',
        abbreviation:'缩写'
      },
      list:{
        app_list:'应用列表',
        new_app:'新增应用',
      },
      sdklist:{
        sdk_list:'SDK列表',
        adk_name:'SDK名称',
        new_sdk:'新增SDK',
        add:'添加',
        live_table_screen:'直播插屏',
        play_page_banner:'播放页banner',
        play_banner:'播放中banner',
        info_flow:'信息流',
        before_patch:'前贴片',
        resource_group:'资源组',
        cdn_management:'CDN管理',
        new_ad:'新版广告',
        old_ad:'旧版广告',
      },
      select_market:{
        batch_add:'批量添加',
      },
      upgrade_detail:{
        version_config:'版本配置',
        config_name:'配置名称',
        Select_upgrade_channels:'选择升级渠道',
        reselect:'重新选择',
        target_version:'目标版本',
        version_type:"升级类型",
        system:'系统',
        up_version:'升级版本',
        target_up_num:"目标升级人数",
        current_up_num:"当前升级人数",
        upload_app:'上传app',
        fill_url:'填写URL',
        select_file:'选择文件',
        Popup_msg:'弹框提示内容',
      },
      upgrade_list:{
        upgrade_management:'升级管理',
        new_upgrade_config:'新增升级配置',
        config_name:'配置名称',
        associated_channel:'关联渠道',
        disable:'禁用',
        start_using:'启用',
        view_details:'查看详情',
      },
      version_sdk:{},
      version:{}
    },
    cdn:{
      common:{
        keyword:'关键字',
        category:'类别',
        all:'所有',
        select:'选择',
        name:'名称',
        antistop:'关键词',
        provider:'提供商',
        domains:'域名',
        operation:'操作',
        add_domain:'添加域名',
        instructions:'说明',
        compile:'编辑',
        del:'删除',
        batch_delete:'批量删除',
        change:'更改',
        related_video:'关联视频',
        default_cdn_settings:'默认CDN设置',
        cdn_set:'CDN设置',
        num:'数量',
      },
      addvideo:{
        add_existing:'添加已有',
        tv_play:'电视剧',
        movie:'电影',
        video_name:'视频名称',
        batch_add:'批量添加',
        determine:'确定',
      },
      global_cnd_list:{
        cdn_list:'CDN列表',
        resource_number:'资源数量',
      },
      global_default_setting:{
        default_global_cdn:'默认全局CDN',
      },
      index:{},
      list:{
        resource_management:'资源管理',
        view_all:'查看所有',
      },
      update:{
        may_fill:'没有可不填',
        class_type:'分类类型',
      },
      video:{
        add:'添加',
        the_current:'当前',
        title:'标题',
        replace:'更换',
        remove:'移除',
        batch_replace:'批量更换',
      }
    },
    common:{
      common:{
        name:'名称',
        select:'选择',
        creation_time:'创建时间',
        operation:'操作',
        dibble_seeding:'点播',
        live:'直播',
        classification:'分类',
        thumbnail:'缩略图',
        state:'状态',
        online:'上线',
        offline:'下线',
        batch_add:'批量添加',
        confirm:'确定',
      },
      area_push:{
        select_territory_list:'选择地域组',
        describe:'描述',
        shielding:'屏蔽',
      },
      cdn_group:{
        select_resource_group:'选择资源组',
      },
      content_config:{
        dibble_seeding_video:'点播视频',
        live_channels:'直播频道',
        add:'添加',
        all_associated:'关联所有',
        video_name:'视频标题',
        channel_name:'频道名称',
        remove:'移除',
      },
      content_select:{
        sort_time:'排序时间',
        release_time:'发布时间',
        update_time:'更新时间',
        synchronization_time:'同步时间',
        title:'标题',
        publish_status:'状态',
        artist:'艺术家',
        author:'作者',
        current_shows:'已有剧集',
        all_show:'总剧集',
        associated_song:'关联歌曲',
      },
      epg_push:{
        select_show:'选择视频',
        name_or_id:'输入剧集名称或ID',
        start_time:'开始时间',
        end_time:'结束时间',
      },
      property_select:{
        check_all:'全选',
        more:'更多',
      },
      resource_group_copy:{
        resource_management:'资源管理',
      },
      resource_group_copys:{
        on_demand_resource_group:'资源管理',
        live_resources_group:'直播资源组',
      },
      resource_group:{
        resource_group:'资源组',
        resource:'资源',
        broadcast:'广播',
      },
      stream_push:{
        choose_live:'选择直播',
      },
      video_push:{
        choose_dibble_seeding:'选择点播',
        alreadyhaveset_and_allset:'已有集数/总集数',
        type:'类型',
      },
      broadcast_push:{
        choose_broadcast:'选择广播'
      },
      rule_add:{
        channel_viewset:'频道观看设置',
        area:'地域',
        user_name:'用户名',
        area_select:'通过地域选择',
        crowd_select:'通过人群选择',
        shield:'屏蔽',
        allow_view:'允许观看',
        program:'节目',
        time_block:'时段',
        start_time:'开始时间',
        end_time:'结束时间',
        to:'至',
        select_program:'点击选择节目',
        save:'保存',
        add_program:'添加节目',
        select_date:'选择日期',
        program_name:'节目名称',
        date:'日期',
      },
      rule_push:{
        select_area:'选择地域',
        select_crowd:'选择人群',
        area_groupname:'地域组名称',
        user_groupname:'用户组名称',
        area_groupid:'地域组id',
        explain:'说明',
        user_groupid:'用户组id',
        group_name:'组名',
      }
    },
    content:{
      menu_name:'菜单名称',
      icon:'图标',
      choose_image:'选择图片',
      sort:'排序',
      menu_list:'菜单列表',
      add_menu:'添加菜单',
      page:{
        name:'页面名称',
        client_name:'客户端显示名称',
        alias:'别名',
        page_type:'页面类别',
        url:'URL',
        choose_library:'选择片库',
        category:'分组',
        page_type_show_page:'展示页面',
        page_type_mine:'我的',
        page_type_h5:'h5',
        page_type_library:'片库'
      },
      commons:{
        recommended_words:'推荐语',
        select_thwartwise_picture:'选择横图',
        select_vertical_picture:'选择竖图',
        content_type:'内容类型',
        associated_content:'关联内容',
        click_select:'点击选择',
        start_time:'开始时间',
        end_time:'结束时间',
        dibble_seeding_programmes:'点播节目',
        live_channels:'直播频道',
        enter_id_or_keyword:'输入id或关键字',
        name:'名称',
        operation:'操作',
        choose:'选择',
        page_library:'页面库',
        all:'全部',
        content_name:'内容名称',
        classify:'分类',
        alreadyhaveset_and_allset:'已有集数/总集数',
        cataloging_languages:'编目语言',
        address:'地址',
        ad:'广告',
        page:'页面',
        new:'新建',
        title:'标题',
        type:'类型',
        status:'状态',
        start_use:'启用',
        disable:'禁用',
        modification:'修改',
        delete:'删除',
        list:'列表',
        display_mode:'显示方式',
        display_content:'显示内容',
        score:'评分',
        id_or_name:'ID或名称',
        all_categories:'所有分类',
        all_state:'所有状态',
        online:'上线',
        offline:'下线',
        compile:'编辑',
        category:'类别',
        home_page:'首页',
        live:'直播',
        focus_picture:'焦点图',
        layout:'布局',
        automatic_filling:'自动填充',
        show:'显示',
        not_show:'不显示',
        attribute:'属性',
        without:'无',
        set:'设置',
        player:'播放器',
        hot_search_list:'热搜列表',
        recommend_words:'推荐文字',
        thumbnails:'缩略图',
        ad_title:'广告名称',
        ad_position:'广告位置',
        ad_provider:'广告提供商',
        guess_like:'猜你喜欢',
      },
      common:{
        pagegroup_add:{
          folder_name:'Folder name',
        },
        select_person:{
          characters:'人物身份',
          director:'导演',
          actor:'演员',
        }
      },
      focus:{
        focus_bar_add:{
          figure:'人物',
        },
        focus_bar_list:{
          amend_focus_figure:'焦点图修改',
          picture:'图片',
        }
      },
      gallary:{
        index:{
          library_page_set:'片库页面设置',
          screening_items:'筛选项',
        },
        property_list:{
          confirm:'确定',
          check_all:'全选',
        },
        setting:{
          list_set:'列表设置',
          first_column:'一列',
          second_column:'二列',
          third_column:'三列',
          intro:'简介',
        }
      },
      menu:{
        menu_list:{
          content_management:'内容管理',
        }
      },
      module:{
        module_list:{
          module_lists:'模块列表',
          add_module:'添加模块',
        }
      },
      section:{
        icon_section:{
          icon_list:'icon组',
        },
        section_add:{
          group_name:'分组名称',
          horizontal_tiled:'横版平铺',
          vertical_tiled:'竖版平铺',
          icon_group:'图标组',
          icon_list:'图标列表',
          picture_scroll_interval:'图片滚动间隔',
          above_gap:'上方空隙',
          per_line_num:'每行显示数量',
          online_number:'在线人数',
          hot_sign:'热门标志',
          select_resource_group:'选择资源组',
          title_right:'标题右侧',
          right_side_words:'右侧文字',
          label:'标签',
          expiration_time:'过期时间',
          day:'天',
          real_media:'real媒资',
        },
        section_list:{
          group_list:'分组列表',
          add_group:'添加分组',
        }
      },
      streampage:{
        index:{
          live_page_set:'直播页面设置'
        },
        mobile:{
          programme_bill:'节目单',
          chat:'聊一聊',
        }
      },
      topsearch:{
        index:{
          search_page_set:'搜索页面设置',
          search_box:'搜索框',
        },
        setting:{
          hot_search_title:'热搜标题'
        }
      },
      video:{
        video_bar_add:{
          related_series:'关联剧集',
          cover:'封面图',
          hottest_live:'直播最热',
          latest_live:'直播最新',
          select_content_type:'请选择内容类型',
        },
        video_bar_form:{
          video_list_modification:'视频列表修改',
          column:'列',
        },
        video_bar_list:{
          content_editing:'自定义点播内容编辑',
          film_title:'片名',
          dibble_seeding:'点播',
          series:'剧集',
        }
      },
      videopage:{
        index:{
          dibble_seeding_page_set:'点播页面设置',
        },
        like:{
          associated_ad:'关联广告',
        },
        mobile:{
          choose_episode:'选集',
          film_intro:'影片介绍',
        },
        player:{
          player_ad:'播放器广告',
          front_screen_ad:'前插屏广告',
          play_banner:'播放banner',
          exit_ads:'退出播放广告',
          play_loading:'播放loading',
          preface_ad:'前贴片广告',
        }
      },
      copy_page:{
        all_versions:'所有版本',
        all_platforms:'所有平台',
        page_name_alias:'页面名称或别名',
        version:'版本',
        platform:'平台',
        page_alias:'页面别名',
        synchronization:'同步',
        synchronous_success:'同步成功',
      },
      index:{
        clients_set:'客户端设置',
        copy_pages:'复制页面',
        successfully_delete:'删除成功',
        config_page:'页面配置',
      },
      property:{
        add:'添加',
        coding:'编码',
        identity:'身份',
      },
      title_bar_form:{
        title_bar_set:'标题栏设置',
        upload_pictures:'上传图片',
      }
    },
    contentbind:{
      common:{
        series_matching:'剧集匹配',
        video_name:'视频名称',
        corresponding_video:'对应视频',
        status:'状态',
        all:'所有',
        matched:'已匹配',
        not_match:'未匹配',
        operation:'操作',
        modification:'修改',
        choose:'选择',
        source_operator:'来源运营商',
        mobile_name:'手机电视频道名称',
        remove_match:'移除匹配',
      },
      episode_list:{
        series_name:'剧集名称',
        matching_situation:'匹配情况',
        mobile_tv_series:'手机电视剧集',
      },
      stream_list:{
        live_content_matching:'直播内容匹配',
        channelname:'频道名称',
        corresponding_channel:'对应频道',
        mobile_number:'手机电视频道编号',
      },
      video_list:{
        dibble_seeding_matching:'点播内容匹配',
        dibble_seeding_video:'点播视频',
        video_matching:'视频匹配',
        mobile_video_number:'手机电视视频编号',
        mobile_dibble_seeding_type:'手机电视点播类别',
        check_series:'查看剧集',
        movie:'电影',
        tv_play:'电视剧',
      }
    },
    mmsprovider:{
      list:{
        media_server_management:'媒资服务器管理',
        add:'添加',
        server_name:'服务器名称',
        server_address:'服务器地址',
        type:'类型',
        synchronous_cycle:'同步周期(秒)',
        operation:'操作',
        modification:'修改',
        del:'删除',
      }
    },
    recommend:{
      category_list:{
        list:'分类管理',
        name:'分类名称',
        type:'类型',
        recommend:'猜你喜欢',
        recommend_count:'猜你喜欢设置',
      },
      recommend_list:{
        refresh:'刷新',
        sort:'排序',
      }
    },
    notify:{
      common:{
        dibble_seeding_programmes:'点播节目',
        live_channels:'直播频道',
      },
      edit:{
        push_editor:'推送编辑',
        new_theme:'新建主题',
        message_content:'消息内容',
        push_type:'推送类型',
        system_message:'系统消息',
        dibble_seeding:'点播',
        live:'直播',
        push_page:'推送页面',
        click_select:'点击选择',
        push_version:'推送版本',
        associated_channel:'关联渠道',
        push_object:'推送对象',
        unlimited:'无限制',
        select_push:'选中推送',
        select_not_push:'选中不推送',
        regional_group:'地域组',
        push_time:'推送时间',
        immediately_send:'立即发送',
        regularly_send:'定时发送',
        user_group:'人群',
      },
      list:{
        message_list:'消息列表',
        new_message:'新增消息',
        serial_number:'编号',
        title:'标题',
        channel:'渠道',
        state:'状态',
        add_time:'添加时间',
        send_time:'发送时间',
        operation:'操作',
        compile:'编辑',
        del:'删除',
        not_push:'未推送',
        have_push:'已推送',
      },
      statistics:{
        notify_statistics:'推送统计',
        transmissions:'下发数',
        deliveries:'到达数',
        clicks:'点击数',
        impressions:'展示数',
        expire:'有效期',
        content_title:'关联内容',
        content_type:'内容类型',
      }
    },
    resource_group:{
      commons:{
        add_resource_group:'添加资源组',
        live_channel:'直播频道',
        choice:'选择',
        operation:'操作',
      },
      common:{
        preview:{
          protagonist:'主演',
          director:'导演',
          synopsis:'简介',
          series_list:'剧集列表',
          clarity:'清晰度',
          original_video:'原始视频',
        }
      },
      episode_list:{
        add_series:'添加剧集',
        sort_save:'保存排序',
        modify_series:'修改剧集',
        preview:'预览',
        transcoding_again:'重新转码',
        delete_respective_series:'删除分集',
        done:'已完成',
        waiting_transcoding:'等待转码',
        is_transcoding:'正在转码',
        transcoding_failure:'转码失败',
        transcoding_suspend:'转码中止',
        transcoding_complete:'转码完成',
        unknown_state:'未知状态',
      },
      group_add:{
        new_resource_group:'新建资源组',
      },
      group_list_tree:{
        delete_resource_group:'删除资源组',
      },
      group_list:{
        system_group:'系统分组',
        app_group:'应用分组',
        all:'全部',
        not_grouped:'未分组',
      },
      stream_share:{
        live_share:'直播分享',
        add:'添加',
        live_share_head:'直播分享标题',
        notice_time:'预告开始时间',
        live_share_time:'直播分享时间',
        jump_url:'跳转地址',
        live_share_icon:'直播分享icon',
        recommended_words:'推荐文字',
        limited_character_number:'限制字符数为',
        total:'全部',
        not_begin:'未开始',
        appointment:'预约中',
        broadcast_live:'直播中',
        finished:'已结束',
        add_time:'添加时间',
        active_state:'活动状态',
        edit:'编辑',
        delete:'删除',
      },
      stream_share_add:{
        click_select:'点击选择',
        local_upload:'本地上传',
        save:'保存',
        to:' 至 ',
      }
    },
    stream:{
      common:{
        name:'名称',
        select:'选择',
        start_time:'开始时间',
        operation:'操作',
        territory_set:'地域设置',
        del:'删除',
        have_published:'已发布',
        has_withdrawn:'已撤回',
        deleted:'已删除',
        draft:'草稿',
        channel_name:'频道名称',
        all:'所有',
        online:'上线',
        offline:'下线',
        state:'状态',
        creation_time:'创建时间',
        conditional_type:'条件类型',
        conditional_detail:'条件详情',
        shield_allow_view:'屏蔽/允许观看',
        end_time:'结束时间',
        state:'状态',
        operation:'操作',
        del:'删除',
        select_object:'选择对象',
        shield_allow:'屏蔽/允许',
        time:'时间',
        area:'地域',
        crowd:'人群',
        allow_view:'允许观看',
        shield:'屏蔽',
        effective:'生效中',
        finished:'已结束',
        not_started:'未开始',
        batch_del:'批量删除',
      },
      area_push:{
        territory_shielding:'地域屏蔽',
        shielding:'屏蔽',
      },
      epg_list:{
        programme_menu:'直播列表(epg)',
        new_programme_menu:"新增节目列表",
        associated_name:"关联视频",
        program_name:'节目名称',
        series:'剧集',
        member_set:'会员设置',
      },
      list:{
        live_video_library:'直播视频库',
        add_existing_channels:'添加已有频道',
        all_state:'所有状态',
        whether_association:'是否关联',
        barrage:'弹幕',
        open:'开启',
        shut_down:'关闭',
        shielding_set:'屏蔽设置',
        view_source:'查看源',
        program_menu_set:'节目单设置',
        program_menu:'epg',
        open_barrage:'开启弹幕',
        close_barrage:'关闭弹幕',
        channel_set:'频道设置',
        timeblock_set:'时段设置',
      },
      push:{
        add_have_already_live:'添加已有直播',
        live_name:'直播名称',
        video_type:'视频类型',
        creator:'创建人',
        batch_add:'批量添加',
      },
      setting:{
        player:'播放器',
      },
      source_list:{
        live_source_list:'直播源列表',
        fluency:'流畅',
        standard_definition:'标清',
        high_definition:'高清',
        ultra_high_definition:'超高清',
        source_name:'源名称',
        sharpness:'清晰度',
        bit_rate:'码率',
        address:'地址',
        proportion:'比例',
        share:'分享',
        preview:'预览',
        shareable:'可分享',
        not_sharable:'不可分享',
        is:'是',
        no:'否',
      },
      timeblock_list:{
        shielding_management:'屏蔽管理',
        add:'添加',
        program_shielding:'节目屏蔽',
        time_shielding:'时间段屏蔽',
        end_time:'结束时间',
        select_program:'选择节目',
        modification:'修改',
      },
      channel_set:{
        view_set:'观看设置',
        add_view_set:'添加观看设置',
      },
      time_set:{
        time_set:'时段设置',
        add_set:'添加时段/节目观看设置',
        setup_mode:'设置方式',
        program_name:'节目名称',
        select_program:'选择节目',
        program:'节目',
        time_block:'时段',
      }
    },
    system:{
      common:{
        add:'添加',
        start_time:'开始时间',
        end_time:'结束时间',
        live_channels:'直播频道',
        operation:'操作',
        compile:'编辑',
        del:'删除',
        edit_territory_group:'编辑地域组',
        submit:'提交',
        territory_group_name:'地域组名称',
        territory_group_explain:'地域组说明',
        territory_select:'地域选择',
        waiting_choice:'待选择',
        have_chosen:'已选择',
        creation_time:'创建时间',
      },
      activity_list:{
        tv_red_envelope_setting:'电视红包设置',
        select_version:'选择版本',
        selected_channel:'选择渠道',
        title:'标题',
        version:'版本',
        channel:'渠道',
        dibble_seeding_video:'点播视频',
        associated_content:'关联内容',
      },
      area_edit:{
        refresh:'刷新',
      },
      area_list:{
        territory_group_management:'地域组管理',
        create_new_territory_group:'创建新的地域组',
        select:'选择',
        name:'名称',
        explain:'说明',
        batch_delete:'批量删除',
      },
      provider_list:{
        provider_management:'提供方管理',
        provider:'提供方',
        video_count:'视频数量',
        channel_count:'渠道数量',
        choose_channel:'选择渠道'
      },
      channel_list:{
        channel_management:'渠道管理',
        channel_name:'渠道名',
        alias:'别名',
        platform:'平台',
        installation_number:'安装数量',
        Cumulative_publish_versions:'累计发布版本',
        latest_version:'最新版本',
      },
      schedule_list:{
        dibble_seeding_timing_task:'点播定时任务',
        live_timing_task:'直播定时任务',
        add_timing_task:'添加定时任务',
        all_dibble_seeding_video:'所有点播视频',
        all_live_programmes:'所有直播节目',
        task_type:'任务类型',
        content_type:'内容类型',
        state:'状态',
        running:'运行中',
        suspend:'暂停',
        modification:'修改',
      },
      streamevent_list:{
        activity_live_sharing:'活动直播分享',
        activity_live_name:'活动直播名称',
        publicity_pictures:'宣传图片',
        trailer_start_time:'预告开始时间',
        live_start_time:'直播开始时间',
        live_end_time:'直播结束时间',
        click_select:'点击选择',
        active_state:'活动状态',
        add_time:'添加时间',
      }
    },
    video:{
      common:{
        territory_shield:'地域屏蔽',
        name:'名称',
        select:'选择',
        shielding:'屏蔽',
        territory_set:'地域设置',
        selected_name:'选集名',
        member:'会员',
        not_member:'非会员',
        downloadable:'可下载',
        not_download:'不可下载',
        creation_time:'创建时间',
        operation:'操作',
        preview:'预览',
        all:'所有',
        online:'上线',
        offline:'下线',
        state:'状态',
      },
      area_push:{
        shielding_territory:'屏蔽地域',
        select_territory_plan:'选择地域方案',
        series_name:'剧集名称',
      },
      area_select:{
        confirm:'确定',
      },
      area:{
        users_block:'用户屏蔽',
        batch_shielding:'批量屏蔽',
        batch_through:'批量通过',
      },
      cms_video_list:{
        dibble_seeding_video:'点播视频',
        add_video:'添加视频',
        has_episode:'已有集数',
        just_look_current_folder:'仅看当前文件夹',
        view_all:'查看所有',
        id_or_name:'ID或名称',
        all_state:'所有状态',
        classification:'分类',
        language:'语言',
        all_episode:'总集数',
        barrage:'弹幕',
        ad:'广告',
        open:'开启',
        shut:'关闭',
        view_details:'查看详情',
        open_barrage:'开启弹幕',
        close_barrage:'关闭弹幕',
        removed_from:'移出',
        stop_selling:'停止售卖',
        is_selling:'正在售卖',
        video_view_set:'地域屏蔽',
      },
      detail:{
        video_details:'视频详情',
        submit:'提交',
        all_member_types:'所有会员类型',
        all_download_types:'所有下载类型',
        onoff:'上下线',
        share_status:'分享状态',
        shareable:'可分享',
        not_share:'不可分享',
        member_type:'会员类型',
        download_type:'下载类型',
        download_set:'下载设置',
        sharing_set:'分享设置',
        batch_online:'批量上线',
        batch_offline:'批量下线',
        batch_sharing_setup:'批量分享设置',
        batch_download_settings:'批量下载设置',
        batch_territory_settings:'批量地域设置',
        view_set:'观看设置',
        bit_set:'码率设置',
        wait_bit:'待选码率',
        selected_bit:'已选码率',
      },
      preview:{
        sharpness:'清晰度',
        synopsis:'简介',
        series_list:'剧集列表',
      },
      push:{
        add_existing_dibble_seeding:'添加已有点播',
        live_name:'直播名称',
        video_type:'视频类型',
        creator:'创建人',
        batch_add:'批量添加',
      },
      view_set:{
        view_set:'观看设置',
        add_set:'添加观看设置',
        create_time:'创建时间',
        conditional_type:'条件类型',
        conditional_detail:'条件详情',
        shield_allow_view:'屏蔽/允许观看',
        start_time:'开始时间',
        end_time:'结束时间',
        state:'状态',
        operation:'操作',
        del:'删除',
        select_object:'选择对象',
        shield_allow:'屏蔽/允许',
        time:'时间',
        area:'地域',
        crowd:'人群',
        allow_view:'允许观看',
        shield:'屏蔽',
        effective:'生效中',
        finished:'已结束',
        not_started:'未开始',
        batch_del:'批量删除',
        content_ID:'内容ID',
        content_type:'内容类型',
      }
    },
    broadcast:{
      list:{
        title:'广播库',
        broadcast_name:'广播名称',
        all_state:'所有状态'
      }
    }
  },
  admin:{
    common:{
      real_name:'真实姓名',
      role_group_name:'角色组名',
      operation:'操作',
      compile:'编辑',
      del:'删除',
    },
    addaccount:{
      new_account_role:'新建账号角色',
      user_name:'用户名',
      password:'密码',
      email:'邮箱',
      phone_number:'手机号码',
      select_role_grouping:'选择角色分组',
      set_new_password:'设置新密码',
    },
    addrole:{
      modification:'修改',
      new:'新建',
      account_role:'账号角色',
      copyright_explain:'权限说明',
      edit_permission:'编辑权限',
    },
    adminlist:{
      account_management:'账号管理',
      new_account:'新增账号',
      grouping:'分组',
      account_name:'账号名称',
      group:'组别',
      phone:'联系电话',
    },
    modules:{
      all_permissions:'所有权限',
      add_module:'添加模块',
      method_name:'方法名',
      parent_module:'父模块',
      subordinate_module:'所属模块',
      search_module:'搜索模块',
      name:'名称',
      module:'模块',
    },
    rolelist:{
      role_group_management:'角色组管理',
      new_role_group:'新增角色组',
      explain:'说明',
      number_characters:'角色账号人数',
      app_management:'管理应用',
      sdk_management:'管理SDK',
    },
  },
  bigdata:{
    common:{
      channel_statistics:'频道统计',
      name:'名称',
      ad_types:'广告类型',
      advertisers:'广告商',
      channel:'渠道',
      times_play:'播放次数',
      running_time:'播放时长',
      play_user:'播放用户',
      search_times:'搜索次数',
      comment_times:'评论次数',
      collect_times:'收藏次数',
      amount_downloads:'下载次数',
      start_time:'开始时间',
      end_time:'结束时间',
      users_retained:'用户留存',
      new_user:'新用户',
      activate_user:'启动用户',
      start_up_time:'启动次数',
      gross:'总量',
      version:'版本',
      according_hours:'按时',
      according_date:'按日',
      according_week:'按周',
      according_month:'按月',
      select_time:'选择时间',
      platform:'平台',
      channel:'渠道',
      time:'时间',
      channel_name:'频道名称',
      channel_category:'频道类别',
      belongs_cp:'所属CP',
      operation:'操作',
      detailed_data:'详细数据',
      new_users:'新增用户',
      new_users_ratio:'新增用户占比',
      unfold_screening:'展开筛选',
      pack_up_screening:'收起筛选',
      use_flowrate:'使用流量',
      num:'个',
      video:'视频',
      video_name:'视频名称',
      flowrate:'流量',
      video_category:'视频类别',
      language:'语言',
      date:'日期',
      view_program:'查看节目',
    },
    ad:{
      adplace_summary:{
        channel:'频道',
      },
      unit_summary:{
        ad_unit_statistics:'广告单元统计',
        ad_unit:'广告单元',
        type:'类型',
        requests_number:'请求数',
        request_successful:'请求成功',
        request_failed:'请求失败',
        request_timeout:'请求超时',
        request_success_before_timeout:'超时前请求成功',
        request_failed_before_timeout:'超时前请求失败',
        exposure:'曝光',
        click:'点击',
        fill_rates:'填充率',
        exposure_rate:'曝光率',
        click_rate:'点击率',
      }
    },
    basic:{
      app_summary:{
        app_general_situation:'应用概况',
        today:'今日',
        yesterday:'昨日',
        error_rate:'错误率',
        recent7:'(最近7日)',
        first_use:'首次使用',
        the:'第',
        day:'天',
        per_capita_startup_times:'人均启动次数',
        duration_each_use:'每次使用时长',
        duration_per_person:'每人使用时长',
        app_name:'应用名称',
        category:'类别',
      },
      user_active:{
        active_user_analysis:'活跃用户分析',
        active_users:'活跃用户',
        active_users_ratio:'活跃用户',
      },
      user_area:{
        terrain_analysis:'地域分析',
        region:'地区',
      },
      user_channel:{
        channel_analysis:'渠道分析',
        channel_name:'渠道名称',
        average_length:'平均使用时长',
      },
      user_client:{
        analysis_terminal:'终端分析',
        equipment_type:'设备型号',
        operating_system:'操作系统',
        resolution_ratio:'分辨率',
        operator:'运营商',
        networking_way:'联网方式',
      },
      user_new:{
        new_user_ratio:'新用户占比',
      },
      user_remains:{
        first_use_date:'首次使用日期',
        day_later:'天后',
      },
      user_summary:{
        user_analysis:'用户分析',
      }
    },
    network_traffic:{
      stream_summary:{
        qualifying_channels:'符合条件的频道',
      },
      video_summary:{
        dibble_seeding_flowrate_statistics:'点播流量统计',
        eligible_video:'符合条件的视频',
      }
    },
    stream:{
      stream_channel_summary:{
        channel_analysis:'频道分析',
      },
      stream_program_summary:{
        program_statistics:'节目统计',
        program_name:'节目名称',
        subordinate_channel:'所属频道',
      }
    },
    video:{
      video_drama_summary:{
        video_statistics:'视频统计',
      },
      video_episode_summary:{
        statistics_series:'剧集统计',
        series:'剧集',
        series_name:'剧集剧集名称',
      },
      video_summary:{
        dibble_seeding_statistics:'点播统计',
        check_series:'查看剧集',
      }
    }
  },
  config:{
    common:{
      new:'新建',
      name:'名称',
      upload_pictures:'上传图片',
      describe:'描述',
      top_left_corner:'左上角',
      top_right_corner:'右上角',
      lower_left_corner:'左下角',
      lower_right_corner:'右下角',
      creation_time:'创建时间',
      operation:'操作',
      compile:'编辑',
      delete:'删除',
      local_name:'本地名称',
      abbreviation:'缩写',
      picture:'图片',
      figure:'人物',
      gender:'性别',
      identity:'身份',
      head_portrait:'头像',
      english_name:'英文名',
      countries:'国家',
      date_birth:'出生日期',
      alias:'别名',
      actor:'演员',
      director:'导演',
      man:'男',
      woman:'女',
      type:'类型',
      language:'语言',
      program_name:'节目名称',
      new_label:'新建标签',
      label_name:'标签名称',
      num:'编号',
      relevance_dibble_seeding_num:'关联点播数量',
      relevance_dibble_seeding_video:'关联点播视频',
      role_name:'名字',
      width:'宽度',
      height:'高度',
      video_bitrate:'视频码率',
      audio_bitrate:'音频码率',
      default:'默认',
      fastest_speed:'最快速度',
      velocity_priority:'速度优先',
      dynamic_equilibrium:'动态均衡',
      image_quality_priority:'画质优先',
      optimal_quality:'最优画质',
      location:'位置',
    },
    cp:{
      list:{
        management:'管理',
        new:'新增',
        address:'地址',
      }
    },
    language:{
      list:{
        Catalog_language_management:'编目语言管理',
        new_language:'新增语言',
      }
    },
    person:{
      add:{
        author:'作者',
        artist:'艺术家',
      },
      list:{
        people_management:'人物管理',
        new_figures:'新增人物',
        figures_type:'人物类型',
      },
      star:{
        star_management:"明星管理",
        star_name:"明星名字",
      }
    },
    ressetting:{
      res_setting:{
        resource_default_config:'资源默认配置',
        save_refresh:'保存并刷新',
        dibble_seeding_set:'点播设置',
        video_up_down_line_set:'视频上下线设置',
        default_referrals:'默认下线',
        default_online:'默认上线',
        series_up_down_set:'剧集上下线设置',
        default_download_set:'默认下载设置',
        not_download:'不可下载',
        downloadable:'可下载',
        default_sharing_set:'默认分享设置',
        not_share:'不可分享',
        shareable:'可分享',
        default_comment_set:'默认评论设置',
        default_line_code_rate:'默认上线码率',
        waiting_select:'待选',
        selected:'已选',
        code_rate_online_number:'码率上线数量',
        all_code_rate:'所有码率',
        fixed_quantity:'固定数量',
        live_set:'直播设置',
        up_down_set:'上下线设置',
        default_set:'默认设置',
        not_comment:'不可评论',
        can_comment:'可评论',
        radio_set:'广播设置',
      }
    },
    tags:{
      attr_add:{
        property_name:'属性名',
        unknown:'未知',
        ordinary:'普通',
      },
      bind_add:{
        program_key:'节目关键字',
        select:'选择',
        relevance_all_selected:'关联所有已选中',
      },
      bind_list:{
        relevance_dibble_seeding_program:'关联点播节目',
        add_relevance:'添加关联',
        program:'节目',
        cancel_relevance:'取消关联',
      },
      category_list:{
        categories_management:'分类管理',
        new_categories:'新增分类',
        categories_name:'分类名称',
      },
      container:{
        delete_attribute:'删除属性',
        add_new_attribute:'添加新属性',
      },
      content_list:{
        content:'内容',
        label_code:'标签码',
      },
      general_list:{
        label_management:'标签管理',
      },
      person_add:{
        new_account_role:'新建账号角色',
      },
      person_list:{
        figure_labels:'人物标签',
        new_figures:'新建人物',
        nationality:'国别',
      }
    },
    transcodeconfig:{
      add:{
        new_transcoding_scheme:'新建转码方案',
        config_name:'配置名称',
        example:'例如：标清(500k) 高清(800k) 超清(1000k)',
        unit:'单位是K',
        bitrate_introduce:'常用音频码率48K、64K、128K；码率不填或为0表示禁止输出音频或视频',
        video_format:'视频格式',
        frame_rate:'帧率',
        frame_spacing:'帧间距',
        frame_number:'帧数量',
        frame_introduce:'-1：关闭B帧，0：不设置数量，其它：设置固定数量',
        bitrate_type:'码率类型',
        coding_rule:'编码规则',
        code_level:'编码级别',
        transcoding_strategy:'转码策略',
        variable_bitrate:'可变码率',
        constant_bitrate:'固定码率',
      },
      list:{
        transcoding_scheme_management:'转码方案管理',
        new_transcoding_scheme:'新增转码方案',
        strategy:'策略',
        submit_time:'提交时间',
      }
    },
    translation:{
      list:{
        translation_management:'翻译管理',
        new_translation:'新增翻译',
        original:'原文',
        old_name:'原名称',
        translate:'翻译',
      }
    },
    watermark:{
      add:{
        new_watermarking:'新建水印',
        margin:'边距',
        level:'水平',
        vertical:'垂直',
      },
      list:{
        watermark_management:'水印管理',
        new_watermark:'新增水印',
        scenario_name:'方案名称',
        level_margin:'水平边距',
        vertical_margin:'垂直边距',
      }
    }
  },
  ims:{
    common:{
      whether_barrage_allowed:'是否允许弹幕',
      all:'所有',
      yes:'是',
      no:'否',
      sorting_by_barrage_num:'根据弹幕数量排序',
      channel:'频道',
      name:'名称',
      barrage_number:'弹幕数',
      operation:'操作',
      management_barrage:'管理弹幕',
      unfinished:'未完善',
      online:'上线',
      offline:'下线',
      user_name:'用户名',
      head_portrait:'头像',
      pass:'通过',
      shield:'屏蔽',
      warning:'报警',
      state:'状态',
      keywords:'关键词',
      select:'选择',
      release_time:'发布时间',
      content:'内容',
      video_name:'视频名',
      issuer:'发布人',
      cause:'原因',
      review_through:'审查通过',
      join_blacklist:'加入黑名单',
      batch_shielding:'批量屏蔽',
      batch_through:'批量通过',
      allow_user_comment:'允许该用户发表评论',
      forbidden_comment:'禁止该用户发表评论',
      close_barrage:'关闭弹幕',
      open_barrage:'开启弹幕',
      column_name:'栏目名称',
      sensitive_words:'敏感词',
      illegal_words:'非法词',
      submit:'提交',
      amend:'修改',
      del:'删除',
      release_shielding:'解除屏蔽',
      platform:'平台',
      selection_time:'选择时间',
      nickname:'昵称',
      name_mother_tongue:'母语名称',
      user_id:'用户id',
      serial_number:'流水号',
      trading_hours:'交易时间',
      transaction_type:'交易类型',
      user_name_id:'用户名或id',
      out_account:'出账',
      into_account:'入账',
      balance:'余额',
      transaction_name:'交易名称',
      goods_order:'商品订单',
      member_order:'会员订单',
      page_recharge_order:'网页充值订单',
      unknown_type:'未知类型',
      selection_platform:'选择平台',
      affiliate_purchases:'关联内购商品',
      take_effect:'生效',
      already_down:'已下架',
      package_id:'套餐id',
      package_name:'套餐名称',
      original_price:'原价',
      shelf_time:'上架时间',
      check_details:'查看明细',
      off_shelf:'下架',
      compile:'编辑',
      is_effect:'正在生效',
      sign_time:'注册时间',
      disable:'禁用',
      start_using:'启用',
      blacklist:'黑名单',
      normal:'正常',
      phone_number:'手机号',
      user_type:'用户类型',
      gold_balance:'金币余额',
      speeches_number:'发言数量',
      banned_state:'禁言状态',
      enabled:'启用状态',
      cancel_banned:'取消禁言',
      banned:'禁言',
      use_activation_code:'使用激活码',
      activation_code_use_success:'激活码使用成功！',
      activation_code_use_failed:'激活码使用失败，请重试！',
      vip_user:'VIP用户',
      average_user:'普通用户',
      release_blacklist:'解除黑名单',
      all_statements:'所有发言',
      activation_code:'激活码',
      white_list_Set:'用户白名单设置',
      add:'添加',
      installation_id:'安装ID',
      explain:'说明',
      join_white_list:'加入白名单',
      generate_number:'生成数量',
      new_activation_code:'新建激活码',
      upload_pictures:'上传图片',
      package_instructions:'套餐说明',
      upper_lower_frame:'上下架状态',
      selling_status:'售卖状态',
      halt_sales:'停止售卖',
      selling:'正在售卖',
      putaway:'上架',
      bindings:'已绑定',
      current_state:'当前状态',
      expired:'已过期',
      level:'级别',
      new:'新增',
      welfare_name:'福利名称',
      captions:'说明文字',
      remaining_days:'剩余天数',
      member_transaction_record:'会员交易记录',
      user_list:'用户列表',
      live_watch_time:'直播观看时长',
      stream_watch_time:'点播观看时长',
      barrage_number:'弹幕数量',
      purchase_amount:'VIP购买金额',
      sign_days:'登录天数',
    },
    barrage:{
      channellist:{
        channel_details:'频道详情',
        channel_keyword:'输入频道关键字',
        channel_id_sorting:'频道ID排序',
      },
      commentmanage:{
        new_barrage:'新增弹幕',
        create_user:'创建用户',
        please_select_program:'请选择节目',
        barrage_time_point:'弹幕时间点',
        after_start_program:'(节目开始后 时:分:秒)',
        send:'发送',
        city:'城市',
        real_time_monitoring:'实时监控',
        shielding_barrage:'屏蔽弹幕',
        delete_blacklist:'删除黑名单',
        channel_barrage:'频道弹幕',
        column_barrage:'栏目弹幕',
        all_barrage:'所有弹幕',
        select_user:'请选择一名用户',
        comment_success:'评论成功！',
        comments_failed:'评论失败，请重试！',
        users_create_success:'新用户创建成功！',
        user_creation_failed:'新用户创建失败，请重试！',
      },
      commentswitch:{
        barrage_switch_management:'弹幕开关管理',
        column:'栏目',
        enter_channel_keyword:'输入频道关键词',
        whether_not:'是否关联',
        classification:'分类',
        series_shielding:'剧集屏蔽',
        enter_column_keywords:'输入栏目关键词',
      },
      episodetable:{
        batch_closed:'批量关闭',
        batch_open:'批量开启',
      },
      keywordalarm:{
        Keyword_alarm_processing:'关键词报警处理',
        publish_content:'发表内容',
        review_status:'评论状态',
        alarm_type:'报警类型',
        pass_examination:'通过审查',
      },
      keywordmanage:{
        keyword_management:'关键词管理',
        type:'类型',
        search_keywords:'搜索关键词',
        add_keywords:'添加关键词',
        batch_import:'批量导入',
        add_time:'添加时间',
        import_success:'导入成功！',
        import_failure:'导入失败，请重试！',
        select_csv_file:'请选择csv文件',
      },
      programlist:{
        column_details:'栏目详情',
        column_type:'栏目类型',
        enter_column_keyword:'输入栏目关键字',
        Sort_column_creation_time:'根据栏目创建时间排序',
        column_id:'栏目id',
      },
      realtimecomment:{
        users_remove_blacklist:'用户解除黑名单',
        users_join_blacklist:'用户加入黑名单',
      },
      usercommentlist:{
        all_user_statements:'用户所有发言',
      }
    },
    feedback:{
      list:{
        device_id:"设备ID",
        feedback_problems:'反馈问题',
        replied:'已回复',
        unanswered:'未回复',
        read_no_reply:'已读未回复',
        equipment:'设备',
        submit_time:'提交时间',
        system_version:'系统版本',
        software_version:'软件版本',
        read:'已读',
        reply:'回复',
        transfer_business:'转至商务',
        batch_mark_read:'批量标记为已读',
        batch_transfer_business:'批量转至商务',
        unknown_device:'未知设备',
      }
    },
    gold:{
      order:{
        gold_coin_trading_flow:'金币交易流水',
      },
      package:{
        gold_coin_exchange:'金币兑换套餐',
        add_new_package:'添加新套餐',
        exchange_gold_coins_num:'兑换金币个数',
        actual_price:'实际价格',
        package_name_id:'套餐名称或id',
        gold_num:'金币个数',
        change_number:'兑换人数',
      }
    },
    user:{
      usercommenttable:{
        speaking_time:'发言时间',
        speech_content:'发言内容',
        speak_state:'发言状态',
        has_shielding:'已屏蔽',
        keyword_alarm:'关键词报警',
        unknown:'未知',
      },
      userdetail:{
        details_personal_information:'个人信息详情',
        remove_gag:'解除禁言',
        user_gag:'用户禁言',
        enable_user:'启用该用户',
        disable_user:'禁用该用户',
        gold_coin_water:'金币使用流水',
        barrage_speak:'弹幕发言',
        gender:'性别',
        equipment_info:'设备信息',
        birthday:'生日',
        client_version:'客户端版本',
        sign_id:'注册IP',
        sign_location:'注册位置',
        last_time_ip:'上次IP',
        last_login_time:'上次登录时间',
        last_location:'上次位置',
        phone:'手机',
        wechat_id:'微信号',
        account_status:'账号状况',
        microblog:'微博',
        speech_situation:'发言状况',
        android:'安卓',
        apple:'苹果',
        unknown_system:'未知系统',
      },
      usergroup:{
        user_group_management:'用户分组管理',
        add_group:'新增分组',
        number:'编号',
        creation_time:'创建时间',
        group_name:'组名',
        condition:'条件',
        current_user:'当前用户',
        operation:'操作',
        modify:'修改',
        delete:'删除',
        and:' 且 ',
        or:' 或 ',
        all_days:'所有天数 ',
        lately:'最近',
        days:'天 ',
      },
      userlist:{
        all_users:'所有用户',
        confirm_use:'确认使用',
        all_registered_users:'所有注册用户',
        sign_today:'今日注册',
        all_vip:'所有VIP',
        user_state:'用户状态',
      },
      whitelist:{
        total_number:'总人数',
        nickname_id:'昵称或安装ID',
        user_nickname:'用户昵称',
        remove:'移除',
      },
      whitelist2:{
        set_criteria:'设置条件',
        user_play_times:'用户过去30天播放次数',
        time:'次',
        user_play_length:'用户过去30天播放总时长',
        minutes:'分钟',
        save_set:'保存设置',
        active_number:'活跃人数',
        white_list:'白名单人数',
        average_playback_times:'平均播放次数',
        average_playback_length:'平均播放时长(分钟)',
        delete_from_list:'从列表中删除',
      },
      whitelistadd:{
        determine:'确定',
      },
      whitelistadd2:{
        enter_name_id:'输入用户名或id',
        search:'搜索',
        user_label:'用户标签',
        white_list:'白名单',
      },
      usergroupadd:{
        add_modify:'新增/修改用户分组',
        group_name:'分组名称',
        add_condition:'添加条件',
        intersection:'交集',
        aggregation:'合集',
        time_frame:'时间范围',
        event:'事件',
        condition:'条件',
        value:'值',
        all_time:'所有时间',
        lately:'最近',
        day:'天',
        yuan:'元',
        percentile:'百分位',
      }
    },
    devicelist:{
      all:{
        all_device:'所有设备',
        device_model:'设备型号',
        device_version:'设备版本',
        device_model_id:"设备版本ID",
        device_status:'设备状态',
        deviceId:'设备ID',
        device_created_time:'创建时间',
        device_started_time:'启动时间',
        view_details:'查看详情',
        modify_status:"修改状态",
        modify:"修改"
      },
      alldetail:{
        user_id:"用户ID",
        user_level:"用户等级",
        user_active_score:"活跃积分",
        user_search_score:"搜索积分",
        user_watch_score:"观看积分",
        user_behavior_score:"观看行为积分",
        device_active_days:"设备活跃天数",
      },
      group:{
        user_id:'用户ID',
        date:'日期',
        installed_at:'加入时间',
        searchs_num:'搜索次数',
        searchs_words:"搜索词数",
        watch_shorts:'高频观看次数',
        total_searchs_num:'总搜索次数',
        total_searchs_words:"总搜索词数",
        total_watch_shorts:'总高频观看次数',
        yesterday_searchs_num:'昨日搜索次数',
        yesterday_searchs_words:"昨日搜索词数",
        yesterday_watch_shorts:'昨日高频观看次数',
        screen_shots:"截图张数",
        emulator:'是否模拟器用户',
        commonly_app:'未安装常用App',
        level:'level',
        status_last:"上次状态",
        view_status:'状态',
        status:'状态类型',
        status_alter:"状态改变",
        active_days:"活跃天数",
        area:'地域',
        report:"报表",
        
        event_statistics:"事件统计"
      },
      devicerule:{
        blacklist_rule:"黑名单规则",
        blacklist_Id:"黑名单ID",
        type:"类型",
        status:"状态",
        rule:"规则",
        creation_time:"创建时间",
        describe:'描述',
        conserve:"保存"
      },
      devicedetail:'设备信息详情',
      user_state:'用户状态',
    },
    vip:{
      addcode:{
        choose_existing_packages:'选择已有套餐',
        exchange_quota:'单个用户兑换限额',
        allowable_exchange_time:'允许兑换时间',
        end_exchange_time:'结束兑换时间',
        modify_activation_code:'修改激活码',
      },
      addvipset:{
        associated_existing_goods:'关联已有商品',
        add_goods:'添加商品',
        present_price:'现价',
        membership_grade:'会员等级',
        membership_days:'会员天数',
        total_package:'套餐总量',
        down_time:'下架时间',
        product_number_name:'输入商品号或商品名',
        commodity_number:'商品号',
        commodity_name:'商品名',
        gifts_gold_coins:'赠送金币数量',
        quantity_goods:'商品数量',
        modify_package:'修改VIP套餐',
        new_package:'新建VIP套餐',
      },
      vipcodedetail:{
        activation_code_detail:'会员激活码明细',
        activation_time:'激活时间',
        binding_package:'绑定套餐',
        total:'总计',
        already_activated:'已激活',
        not_used:'未使用',
        not_effect_time:'未到生效时间',
      },
      vipcodelist:{
        member_activation_code:'会员激活码',
        activation_code_name:'激活码名称',
        generated_time:'生成时间',
        not_beginning_exchange:'未开始兑换',
        serial_number:'序号',
        start_exchange:'开始兑换',
        end_exchange:'结束兑换',
        already_used:'已使用',
        use_detail:'使用明细',
      },
      viplist:{
        list:'列表',
        add_icon:'添加图标',
      },
      vipmemberlist:{
        all_vip_members:'所有VIP会员',
        purchase_times:'购买次数',
        initial_purchase_time:'初次购买时间',
        this_purchase_time:'本次购买时间',
      },
      viporderlist:{
        yuan:'元',
        vip_earnings:'当前条件下，平台共获得VIP收益',
        payment_method:'支付方式',
        all:'全部',
        gold_coin_payment:'金币支付',
        alipay_pay:'支付宝支付',
        wechat_pay:'微信支付',
        apple_purchase:'苹果内购',
        activation_code_activation:'激活码激活',
        transaction_serial_number:'交易流水号',
        purchase_time:'购买时间',
        package_name:'套餐名',
        payment_amount:'支付金额',
        start_effective_time:'开始生效时间',
      },
      vipserverlist:{
        welfare_set:'福利设置',
        save_changes:'保存修改',
      },
      vipsetlist:{
        package_management:'套餐管理',
        new_package:'新增套餐',
        package_name_id:'套餐名或ID',
        time_limit:'时限(天)',
        current_price:'当前售价',
        buy_limit:'购买限制',
      }
    }
  },
  log:{
    log:{
      test_log:'测试日志',
      phone_number:'手机号',
      historical_data:'历史数据',
      empty:'清空',
      time:'时间',
      event_time:'事件时间',
      user_id:'用户id',
      video_id:'视频id',
      event:'事件',
      network:'事件',
      client_system:'客户端系统',
      client_version:'客户端版本',
      app_version:'app版本',
      start:'启动',
      close:'关闭',
      collapse:'崩溃',
      play:'播放',
      start_playing:'开始播放',
      resume_play:'恢复播放',
    }
  },
  media:{
    common:{
      name:'名称',
      classification:'分类',
      select_file:'选择文件',
      score:'评分',
      publication_date:'出版日期',
      cover:'封面',
      author:'作者',
      names:'姓名',
      alias:'别名',
      operation:'操作',
      select:'选择',
      add:'添加',
      new:'新增',
      look_current_folder:'仅看当前文件夹',
      view_all:'查看所有',
      title:'标题',
      state:'状态',
      thumbnails:'缩略图',
      intro:'简介',
      publish:'发布',
      withdraw:'撤回',
      compile:'编辑',
      shift_out:'移出',
      del:'删除',
      batch_publish:'批量发布',
      batch_withdraw:'批量撤回',
      batch_removal:'批量移出',
      transcode_file_management:'转码文件管理',
      video_series_name:'视频/剧集名称',
      all:'所有',
      waiting_transcoding:'等待转码',
      being_transcoding:'正在转码',
      transcoding_failure:'转码失败',
      transcoding_abort:'转码中止',
      transcoding_completion:'转码完成',
      transcoding_scheme:'转码方案',
      video_name:'视频名称',
      series_name:'剧集名称',
      transcoding_state:'转码状态',
      transcoding_progress:'转码进度',
      format:'格式',
      add_time:'添加时间',
      suspend:'暂停',
      unknown_state:'未知状态',
      upload_video:'上传视频',
      select_video_file:'选择电脑中的视频文件',
      selected_file:'已选择文件',
      start_upload:'开始上传',
      filename:'文件名',
      schedule:'进度',
      creator:'创建人',
      upload_time:'上传时间',
      update_time:'更新时间',
      continue_uploading:'继续上传',
      read_file_info:'正在读取文件信息...',
      read_infor_success:'成功获取文件信息...',
      uploading:'上传中',
      uploaded:'已上传',
      upload_error:'上传出错',
      wait_uploading:'等待上传',
      completed:'已完成',
      start_time:'开始时间',
      end_time:'结束时间',
      channel_name:'频道名称',
      describe:'描述',
      determine:'确定',
      keywords:'关键词',
      online:'上线',
      offline:'下线',
      artist:'艺术家',
      creation_time:'创建时间',
      click_selection:'点击选择',
      broadcast_address:'播放地址',
      edit_atlas_infor:'编辑图集信息',
      news_headlines:'新闻标题',
      source:'来源',
      content:'内容',
      time:'时间',
      amend:'修改',
      sharpness:'清晰度',
      episode_list:'剧集列表',
      catalogue_management:'编目管理',
      years:'年代',
      years_ago:'年以前',
      pinyin:'拼音',
      total_series:'总集数',
      term_start:'期限开始',
      term_end:'期限结束',
      synopsis:'剧情简介',
      video_thumbnail:'视频缩略图',
      ott_thumbnail:'ott缩略图',
      add_watermark:'添加水印',
      simplified_chinese:'简体中文',
      remove_from_group:'从资源组中移除',
      please_check:'请勾选!',
      published_status:'已发布状态!',
      withdrawn_release:'已撤回或待发布状态!',
      view_folders:'查看文件夹',
      amend_play:'修改剧集',
      transcoding_file:'转码文件',
      transcoding_again:'重新转码',
      preview:'预览',
      submit:'提交',
      add_resource_group:'添加资源组',
      nickname:'昵称',
      batch_add:'批量添加',
      cancel_set:'取消设置',
      publish_status:'下载状态',
      picture_ratio:'画面比例',
      address:'地址',
      code_rate:'码率',
      smooth:'流畅',
      standard_definition:'标清',
      high_definition:'高清',
      ultra_hd:'超高清',
      source_id:'源ID',
      source_name:'源名称',
      manual_sort:'手动排序',
      cancel_manual_sort:'取消手动排序',
      new_p2p_url:'新P2P地址',
    },
    book:{
      book_detail:{
        edit_book_info:'编辑书籍信息',
        books_file:'书籍文件',
        upload_files:'上传文件',
        reupload_file:'重新上传文件',
        press:'出版社',
        copyright_dealer:'版权商',
        book_description:'书籍简介',
      },
      book_list:{
        book_library:'书籍库',
        num:'字数',
        ebook_size:'电子书大小',
      }
    },
    image:{
      image_list:{
        image_library:'图片库',
        image_url:'图片地址',
        file_type:'文件类型',
        file_size:'文件大小',
        updated_at:'更新时间'
      }
    },
    broadcast:{
      uploader:{
        batch_upload_video:'批量上传视频',
      }
    },
    epg:{
      add_pro:{
        program_name:'节目名称',
      },
      epg_change:{
        third_live_list:'第三方直播列表',
        provider:'提供商',
      },
      list:{
        epg_management:'EPG管理',
        new_epg:'新增EPG',
        check_program_list:'查看节目单',
      },
      program:{
        current_epg:'当前EPG',
        replace_epg:'更换EPG',
        new_program:'新增节目',
        selection_time:'选择时间',
      },
      save:{
        program_document:'节目单文件',
        reselect:'重新选择',
        uploading:'正在上传',
        epg_source:'EPG来源',
        manually_uploading:'手工上传',
      }
    },
    music:{
      album_detail:{
        associated_songs_list:'关联歌曲列表',
        online_status:'上线状态',
        remove:'移除',
        batch_remove:'批量移除',
      },
      album_list:{
        album_management:'专辑管理',
        album_title:'专辑名称',
        album_cover:'专辑封面',
        view_all_songs:'查看所有歌曲',
      },
      music_detail:{
        edit_music_info:'编辑音乐信息',
        song_files:'歌曲文件',
        song_name:'歌曲名称',
        song_time:'歌曲时长',
        source_album:'来源专辑',
        song_introduction:'歌曲简介',
      },
      music_list:{
        music_library:'音乐库',
        music_title:'音乐标题',
        album:'所属专辑',
        duration:'时长',
      }
    },
    news:{
      article_detail:{
        enter_content:'请输入内容',
      },
      article_list:{
        article_lists:'文章列表',
      },
      gallery_detail:{
        replace_cover:'更换封面',
        atlas:'图集',
      },
      gallery_list:{
        atlas_list:'图集列表',
      },
      news_setting:{
        series_matching:'剧集匹配',
        corresponding_video:'对应视频',
        already_matched:'已匹配',
        not_match:'未匹配',
        matching_situation:'匹配情况',
        mobile_series:'手机电视剧集',
      }
    },
    resource_group:{
      common:{
        preview:{
          original_video:'原始视频',
        }
      },
      broadcast_detail:{
        add_attributes:'添加属性',
      },
      broadcast_list:{
        add_existing_broadcast:'添加已有广播',
        create_new_broadcast:'创建新广播',
        broadcast_name:'广播名称',
      },
      episode_add:{
        create_series:'创建剧集',
        upper_level:'上一级',
        return_root:'返回根目录',
        batch_select:'批量选择',
      },
      episode_list_table:{
        watermark:'水印',
      },
      episode_list:{
        add_series:'添加剧集',
        sort_save:'保存排序',
        reverse_sort:'倒序排序',
        del_diversity:'删除分集',
      },
      group_add:{
        new:'新建',
        resource_group:'资源组',
      },
      group_list_tree:{
        del_resource_group:'删除资源组',
        edit_resource_group:'编辑资源组',
      },
      group_list:{
        all:'全部',
        not_grouped:'未分组',
      },
      video_add:{
        new_dibble_seeding_video:'新建点播视频',
        total_episodes:'剧集总数',
      },
      video_detail:{
        reverse_order_series:'剧集逆序排列',
        yes:'是',
        no:'否',
        without:'无',
      },
      video_list:{
        add_existing_video:'添加已有视频',
        create_new_video:'创建新视频',
        add_filter_box:'添加筛选框',
        series_num:'集数',
        occupy_space:'占用空间',
        total_time:'总时长',
        transcode_file_number:'转码文件数',
        series:'剧集',
        publish:'发布',
        conditional_video:'符合条件的视频',
      },
      video_property:{
        check_all:'全选',
      },
      video_push:{
        add_already_video:'添加已有点播视频',
        sort_time:'排序时间',
        release_time:'发布时间',
        update_time:'更新时间',
        existing_total_series:'已有/总剧集',
      }
    },
    source:{
      add:{
        width_height:'宽度×高度',
      },
      list:{
        source_management:'源管理',
        add_source:'添加源',
        modification_time:'修改时间',
      }
    },
    stream:{
      edit:{
        edit_channel:'编辑频道',
        modification_basic_info:'修改基本信息',
        save_basic_info:'保存基本信息',
        clients:'客户端',
        select_cp:'选择cp',
        affiliated_area:'所属地区',
        nationwide:'全国',
        area:'地区',
        select_area:'选择地区',
        refresh_area:'刷新地区',
        class_label:'分类&标签',
        source_config:'源配置',
        program_management:'节目管理',
        access_mode:'接入方式',
        bit_rate:'比特率',
        proportion:'比例',
      },
      list:{
        resource_library:'资源库',
        add_existing_channels:'添加已有频道',
        new_channel:'新增频道',
        whether_associate_epg:'是否关联EPG',
        published:'已发布',
        withdrawn:'已撤回',
        deleted:'已删除',
        draft:'草稿',
      }
    },
    video:{
      transcoding:{
        pause_transcoding:'暂停转码',
      }
    },
    list:{
      feedback_problem:'反馈问题',
      user_name:'用户名',
      replied:'已回复',
      unanswered:'未回复',
      have_read_unanswered:'已读未回复',
      platform:'平台',
      equipment:'设备',
      user_id:'用户id',
      system_version:'系统版本',
      software_version:'软件版本',
      have_read:'已读',
      reply:'回复',
      transfer_business:'转至商务',
      batch_mark_read:'批量标记为已读',
      batch_transfer_business:'批量转至商务',
      unknown_device:'未知设备',
    },
    property:{
      attribute:'属性',
      code:'编码',
      identity:'身份',
    }
  },
  product:{
    common:{
      product_name:'商品名称',
      internal_goods:'内部商品',
      external_goods:'外部商品',
      cash_income:'现金收入',
      gold_income:'金币收入',
    },
    add:{
      new_goods:'新建商品',
      product_category:'商品类别',
      selection_platform:'选择平台',
      associated_internal_purchase:'关联内购商品',
      total_goods:'商品总量',
      shelf_time:'上架时间',
      down_time:'下架时间',
      rights_interests_set:'权益设置',
      gold_num:'金币数量',
      length:'时长(天)',
      purchase_method:'购买方式',
      cash_amount:'现金金额',
      gold_coin_amount:'金币金额',
      commodity_description:'商品说明',
    },
    list:{
      all_goods:'所有商品',
      new_goods:'新增商品',
      state:'状态',
      all:'所有',
      putaway:'上架',
      already_down:'已下架',
      category:'类别',
      up_down_state:'上下架状态',
      product_id:'商品id',
      selling_state:'售卖状态',
      sold_num:'已售数量',
      operation:'操作',
      take_effect:'生效',
      off_shelf:'下架',
      start_use:'启用',
      disable:'禁用',
      check_details:'查看明细',
      compile:'编辑',
      del:'删除',
      stop_selling:'停止售卖',
      is_selling:'正在售卖',
    },
    order:{
      commodity_trading_details:'商品交易明细',
      purchase_time:'购买时间',
      transaction_num:'交易号',
      purchase_users:'购买用户',
    }
  },
  source:{
    common:{
      select_time:'选择时间',
      add:'添加',
      name:'名称',
      state:'状态',
      start_use:'启用',
      disable:'禁用',
      running_state:'运行状态',
      running:'运行中',
      not_running:'未运行',
      operation:'操作',
      amend:'修改',
      del:'删除',
    },
    event_list:{
      event_management:'事件管理',
      message:'信息',
      warning:'警告',
      error:'错误',
      live_stream_name:'直播流名称',
      content:'内容',
      level:'级别',
      live_stream_id:'直播流ID',
      server:'服务器',
      appearance_time:'出现时间',
    },
    live_list:{
      live_source_management:'直播源管理',
      host:'主机',
      live_streaming:'直播流',
      view_events:'查看事件',
    },
    stream_list:{
      flow_column:'流列管理',
      whether_transform_save:'是否转存',
      yes:'是',
      no:'否',
      whether_main_source:'是否为主源',
      source_address:'源地址',
      resolution:'分辨率',
      video_bitrate:'视频码率',
      audio_bitrate:'音频码率',
      publish_address:'发布地址',
      all_ts_files:'所有ts文件',
      start_running:'开始运行',
      stop_running:'停止运行',
    },
    ts_list:{
      ts_file_list:'Ts文件列表',
      file_name:'文件名称',
      path:'路径',
      file_size:'文件大小',
      start_time:'开始时间',
      time_length:'时长',
      whether_synchronization:'是否同步',
      creation_time:'创建时间',
      update_time:'更新时间',
    }
  },
  login:{
    chinatv_system:'Answer.AI Data',
    user_name:'用户名',
    password:'密码',
    remember_password:'记住密码',
    login:'登录',
  }
}
